module.exports = __webpack_public_path__ + "img/bio.78dc8d6e.png";